import script from "./EmployeeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeDialog.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeDialog.vue?vue&type=style&index=0&id=16da5d1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16da5d1f"]])

export default __exports__